import { useEffect, useState } from 'react';

import useFetchData from 'hooks/useFetchData';
import { FRAME_SERVICE_API_URL } from 'utils/defaults';

interface IFrameServiceStatus {
  uploadInProgress: boolean;
}

export const useFrameServiceStatus = () => {
  const { getData } = useFetchData();
  const [uploadInProgress, setUploadInProgress] = useState(false);
  const [isStatusLoading, setIsStatusLoading] = useState(true);

  useEffect(() => {
    const fetchStatus = async () => {
      await getData<IFrameServiceStatus>(FRAME_SERVICE_API_URL, (response) => {
        setUploadInProgress(response.uploadInProgress);
      });
      setIsStatusLoading(false);
    };

    fetchStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { uploadInProgress, isStatusLoading };
};
